import apiFetch from '../apiFetch'

export default function (token, questionId) {
  return apiFetch({ endPoint: `Faq/${questionId}`, method: 'GET', body: null, token: token })
}
